import { productList } from "../../utility/products";
import { CARTADD, CARTDECREMENT, CARTINCREMENT } from "./actionTypes";

const initialState = {
  products: productList,
  cartList: [],
};

const productNCartReducer = (state = initialState, action) => {
  switch (action.type) {
    case CARTADD:
      const copyState = { ...state };
      const copyProducts = [...copyState?.products];
      const copyCartList = [...copyState?.cartList];

      const product = copyProducts.find(
        (item) => item.id === action.payload.id
      );
      const cartItemExist = copyCartList.findIndex(
        (item) => item.id === action.payload.id
      );
      let productIndex = copyProducts.findIndex(
        (item) => item.id === action.payload.id
      );
      let cartItemIndex = copyCartList.findIndex(
        (item) => item.id === action.payload.id
      );

      if (cartItemExist === -1) {
        copyProducts[productIndex].stockQuantity =
          copyProducts[productIndex].stockQuantity - 1;
        return {
          ...copyState,
          products: [...copyProducts],
          cartList: [{ ...product, quantity: 1 }, ...copyCartList],
        };
      } else {
        copyCartList[cartItemIndex].quantity =
          copyCartList[cartItemIndex]?.quantity + 1;
        copyProducts[productIndex].stockQuantity =
          copyProducts[productIndex].stockQuantity - 1;
        return {
          ...copyState,
          products: [...copyProducts],
          cartList: [...copyCartList],
        };
      }

    case CARTINCREMENT:
      const modifyState = { ...state };
      const modifyProducts = [...modifyState?.products];
      const modifyCartList = [...modifyState?.cartList];

      let pIndex = modifyProducts.findIndex(
        (item) => item.id === action.payload.id
      );
      let cartIndex = modifyCartList.findIndex(
        (item) => item.id === action.payload.id
      );

      modifyCartList[cartIndex].quantity =
        modifyCartList[cartIndex].quantity + 1;
      modifyProducts[pIndex].stockQuantity =
        modifyProducts[pIndex].stockQuantity - 1;

      return {
        ...modifyState,
        products: [...modifyProducts],
        cartList: [...modifyCartList],
      };

    case CARTDECREMENT:
      const newState = { ...state };
      const newProducts = [...newState?.products];
      const newCartList = [...newState?.cartList];

      let productIIndex = newProducts.findIndex(
        (item) => item.id === action.payload.id
      );
      let cartIIndex = newCartList.findIndex(
        (item) => item.id === action.payload.id
      );

      newCartList[cartIIndex].quantity = newCartList[cartIIndex].quantity - 1;
      newProducts[productIIndex].stockQuantity =
        newProducts[productIIndex].stockQuantity + 1;

      if (newCartList[cartIIndex].quantity < 1) {
        const modifiedCartItems = newCartList.filter(
          (item) => item?.id !== action.payload.id
        );
        return {
          ...newState,
          products: [...newProducts],
          cartItems: [...modifiedCartItems],
        };
      } else {
        return {
          ...newState,
          products: [...newProducts],
          cartList: [...newCartList],
        };
      }

    default:
      return state;
  }
};

export default productNCartReducer;
